


































































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import PagingUnit from '@/components/paging/paging.vue';
import { patrolManagementServe } from '@/api/installServer';
import EquipEdit from './unit/equip-edit.vue';
import EquipSplit from './unit/equip-split.vue';

@Component({
  components: { CollapseTransition, TreeUnit, PagingUnit, EquipEdit, EquipSplit },
  mixins: [TableStripe],
})
export default class PatrolLine extends Vue {
  private multipleSelection: any = []; // 批量操作数据

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 1000; // 数据总共多少条

  openAsideFlag = true; // 侧边栏是否打开

  private filterForm: any = {
    search: '',
    type: '',
  };

  private typeOptions: any = [
    {
      value: '',
      label: '全部',
    },
    {
      value: '1',
      label: '二维码',
    },
    {
      value: '2',
      label: '蓝牙',
    },
    {
      value: '3',
      label: '蓝牙+二维码',
    },
  ];
  // formShow = false; // 是否显示表单搜索
  // table数据
  tableData: any[] = [];

  showTree(flag: boolean) {
    this.openAsideFlag = flag;
  }

  getNodeIds() {
    this.getPatrolEquipAllData();
  }

  // 公司（单位）数据
  get orgList() {
    return this.$store.state.user.orgList;
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  created() {
    this.getPatrolEquipAllData();
  }

  private getPatrolEquipAllData(): void {
    patrolManagementServe
      .getPatrolEquipAllData({
        paging: true,
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        code: this.filterForm.search ? this.filterForm.search : null,
        type: this.filterForm.type ? this.filterForm.type : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getPatrolEquipAllData();
  }

  /**
   * 【按钮】添加按钮点击事件
   */
  addHandle() {
    const editComponent: any = this.$refs['patrolEquipEdit'];
    editComponent.showAddDialog();
  }

  editHandle(data: any) {
    const editComponent: any = this.$refs['patrolEquipEdit'];
    editComponent.showEditDialog(data);
  }

  /**
   * 【表格】分配操作
   */
  handleSplitBtnClick(data: any) {
    const FacilitySplitComponent: any = this.$refs['patrolEquipSplit'];
    const arr = [];
    arr.push(data);
    FacilitySplitComponent.showDialog(arr);
  }

  /**
   * 批量分配
   */
  handleBatchSplit() {
    const FacilitySplitComponent: any = this.$refs['patrolEquipSplit'];
    const _selectListId = this.multipleSelection;
    FacilitySplitComponent.showDialog(_selectListId);
  }

  /**
   * 【表格】表格内删除按钮
   * @param data
   */
  handleTableDeleteBtnClick(data: any) {
    this.$confirm('此操作将永久删除该巡检设备，是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.removeEquip(data.id);
        // this.getPatrolEquipAllData();
      })
      .catch(() => {});
  }

  /**
   * 【接口】删除巡检设备
   * @param ids
   */
  async removeEquip(ids: string | string[]) {
    try {
      const res: any = await patrolManagementServe.deletePatrolEquip(ids);
      this.getPatrolEquipAllData();
    } catch (e) {
      this.$message.warning('删除失败。');
      throw new Error();
    }
  }

  /**
   *【编辑窗口】编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handlePatrolEquipEditResponse() {
    this.getPatrolEquipAllData();
  }
  /**
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    this.getPatrolEquipAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    // 获取全部数据
    this.getPatrolEquipAllData();
  }

  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }

  /**
   * 【按钮】批量操作按钮指令
   */
  handleBatchCommand(command: string) {
    if (this.multipleSelection.length === 0) {
      this.$message.warning('请选择您要操作的数据。');
      return;
    }
    switch (command) {
      case 'remove':
        this.handleBatchRemove();
        break;
      case 'split':
        this.handleBatchSplit();
        break;
    }
  }

  /**
   * 批量删除
   */
  handleBatchRemove() {
    this.$confirm('此操作将永久删除, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        const _selectList = this.multipleSelection.map((item: any) => item.id);
        this.removeEquip(_selectList);
      })
      .catch(() => {});
  }
}
